<template>
  <div>
    <w-error v-if="model && model != {}" :model="model" />

    <table :class="tableClass" style="margin-bottom: 2em;">
      <slot />
    </table>
  </div>
</template>

<script>
import WError from './error.vue';
export default {
  name: 'WFormTable',
  components: {
    WError
  },
  props: {
    css: {
      type: String,
      default: 'table table-bordered table-fixed-header noborderdisabled valigntop'
    },
    model: Object
  },

  computed: {
    tableClass: {
      get() {
        const arr = [this.css];

        if (this.model) {
          const vv = this.model.$value;
        }

        if (this.model && this.model.$error) {
          arr.push('state-error');
        } else {
          arr.push('state-success');
        }
        return arr;
      }
    }
  }
};
</script>
